import CryptoJS from 'crypto-js'

const key = process.env.VUE_APP_PASS_KEY //  key
const iv = Buffer.alloc(32, 0) //  iv
var functioncryto = {

  encrypt (data) {
    try {
      const cipher = CryptoJS.AES.encrypt(JSON.stringify(data), CryptoJS.enc.Utf8.parse(key), {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC
      })

      return cipher.toString()
    } catch (err) {
      return data
    }
  },
  decrypt (data) {
    // console.log("data3333333", data);
    try {
      const cipher = CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse(key), {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC
      })

      return JSON.parse(CryptoJS.enc.Utf8.stringify(cipher).toString())
    } catch (err) {
      return data
    }
  }

}

export default functioncryto
